import { Component, ChangeDetectorRef, HostListener, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule,  FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Editor,Toolbar,NgxEditorModule } from 'ngx-editor';
import { CreateProjectService } from '../services/create-project.service';
import { finalize } from 'rxjs/operators';
import { RoleViewService } from '../services/role-view.service';

@Component({
  selector: 'app-select-email',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTooltipModule,
    NgxEditorModule
  ],
  templateUrl: './select-email.component.html',
  styleUrl: './select-email.component.css'
})
export class SelectEmailComponent implements OnInit, OnDestroy  {
  editor!: Editor;
  popupEditor!: Editor;
  html = '';
  emailInput = '';
  cardHeightPx = 0;
  scrHeight = '';
  showCc = false;
  showBcc = false;
  collectionName: any = {};
  @Input() emailForm!: FormGroup;
  @Output() emailFormValue = new EventEmitter<any>();
  emailTemplates: any[] = [];
  filteredEmailTemplates: any[] = [];
  templateSearchQuery = '';
  showTemplatePopup = false;
  selectedTemplateId: any = null;
  templateForm!: FormGroup;
  projectName: any;
  emails: string[] = [];
  ccEmails: string[] = [];
  bccEmails: string[] = [];
  deptName: any;
  showAllEmails = false;
  showAllTemplates = false;
  isMobileView = false;
  isEditingTemplate = false;
  editingTemplateId: any = null;
  lastAutoSaveTime: Date | null = null;
  autoSaveTimeAgo = '';
  lastEditedBy = 'John Doe';
  private readonly autoSaveTimer: any;
  private lastFocusedField: 'subject' | 'body' = 'body';
  private lastCursorPosition = 0;
  workDayId : any;
  isLoading = false;
  userRole = '';
  userName = '';


  constructor(private readonly createProjectService: CreateProjectService,private readonly roleviewService: RoleViewService, private readonly cdr: ChangeDetectorRef, private readonly fb: FormBuilder) {
    this.getScreenSize();
    if(this.createProjectService.getSelectedEmail()){
      const savedEmail = this.createProjectService.getSelectedEmail();
      this.emails = Array.isArray(savedEmail) ? savedEmail : (savedEmail.toAddress || []);
      this.ccEmails = savedEmail.ccAddress || [];
      this.bccEmails = savedEmail.bccAddress || [];
    }else{
      this.emails = this.createProjectService.getSelectedDepartment().selectedMembers.map((member: any) => member.email);
    }
  }
  

  @HostListener('window:resize', ['$event'])
  getScreenSize(_event?: Event) {
    this.scrHeight = `${window.innerHeight - 260}px`;
    this.isMobileView = window.innerWidth < 992;
  }

  ngOnInit(): void {
    this.workDayId = this.createProjectService.getWorkdayId();
    this.userRole = this.roleviewService.getAdminAsRole();
     this.userName = this.roleviewService.getUserName();
    this.editor = new Editor();
    this.popupEditor = new Editor();
    this.collectionName = this.createProjectService.getSelectedCollection();
    this.projectName = this.createProjectService.getSelectedProject();
    this.deptName = this.createProjectService.getSelectedDepartment().selectedDepartments;
    console.info("this.getSelectedEmail", this.createProjectService.getSelectedEmail())
    this.fetchEmailTemplate();
    this.loadSavedEmailData();

    this.templateForm = this.fb.group({
      template_name: ['', Validators.required],
      email_subject: ['', Validators.required],
      email_body: ['', Validators.required]
    });
    this.emailForm.get('to')?.setValue(this.emails.join(', '));


  }

  getDisplayEmails(): string {
    if (this.showAllEmails || this.emails.length <= 3) {
      return this.emails.join(', ');
    }
    const displayEmails = this.emails.slice(0, 3).join(', ');
    const remainingCount = this.emails.length - 3;
    return `${displayEmails} +${remainingCount} more`;
  }

  toggleShowAllEmails(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.showAllEmails && this.emails.length > 3) {
      this.showAllEmails = true;
    }
  }

  get visibleTemplates() {
    if (this.isMobileView && !this.showAllTemplates) {
      return this.filteredEmailTemplates.slice(0, 1);
    }
    return this.filteredEmailTemplates;
  }

  get hasMoreTemplates() {
    return this.isMobileView && this.filteredEmailTemplates.length > 1;
  }

  toggleShowAllTemplates() {
    this.showAllTemplates = !this.showAllTemplates;
  }

  onToEmailChange(event: Event) {
    const target = event.target as HTMLElement;
    const value = target.innerText || target.textContent || '';
    this.emailForm.get('to')?.setValue(value, { emitEvent: false });
  }

  updateToFormControl(event: Event) {
    const target = event.target as HTMLElement;
    const value = target.innerText || target.textContent || '';
    this.emailForm.get('to')?.setValue(value.trim());
  }

  removeEmail(index: number) {
    this.emails.splice(index, 1);
    this.emailForm.get('to')?.setValue(this.emails.join(', '));
  }

  addEmail(event: KeyboardEvent) {
    event.preventDefault();
    const input = event.target as HTMLInputElement;
    const email = input.value.trim();

    if (email && this.isValidEmail(email)) {
      this.emails.push(email);
      this.emailForm.get('to')?.setValue(this.emails.join(', '));
      input.value = '';
    }
  }

  addCcEmail(event: KeyboardEvent) {
    event.preventDefault();
    const input = event.target as HTMLInputElement;
    const email = input.value.trim();

    if (email && this.isValidEmail(email)) {
      this.ccEmails.push(email);
      this.emailForm.get('cc')?.setValue(this.ccEmails.join(', '));
      input.value = '';
      this.emailFormValue.emit(this.emailForm.value);
    }
  }

  removeCcEmail(index: number) {
    this.ccEmails.splice(index, 1);
    this.emailForm.get('cc')?.setValue(this.ccEmails.join(', '));
    this.emailFormValue.emit(this.emailForm.value);
  }

  addBccEmail(event: KeyboardEvent) {
    event.preventDefault();
    const input = event.target as HTMLInputElement;
    const email = input.value.trim();

    if (email && this.isValidEmail(email)) {
      this.bccEmails.push(email);
      this.emailForm.get('bcc')?.setValue(this.bccEmails.join(', '));
      input.value = '';
      this.emailFormValue.emit(this.emailForm.value);
    }
  }

  removeBccEmail(index: number) {
    this.bccEmails.splice(index, 1);
    this.emailForm.get('bcc')?.setValue(this.bccEmails.join(', '));
    this.emailFormValue.emit(this.emailForm.value);
  }

  loadSavedEmailData() {
    const savedEmail = this.createProjectService.getSelectedEmail();
    if (savedEmail) {
      // Handle ccAddress array
      if (savedEmail.ccAddress && Array.isArray(savedEmail.ccAddress) && savedEmail.ccAddress.length > 0) {
        this.ccEmails = savedEmail.ccAddress;
        this.showCc = true;
        this.emailForm.get('cc')?.setValue(this.ccEmails.join(', '));
      }
      
      // Handle bccAddress array
      if (savedEmail.bccAddress && Array.isArray(savedEmail.bccAddress) && savedEmail.bccAddress.length > 0) {
        this.bccEmails = savedEmail.bccAddress;
        this.showBcc = true;
        this.emailForm.get('bcc')?.setValue(this.bccEmails.join(', '));
      }
      
      // Handle subject and body if present
      if (savedEmail.emailSubject) {
        this.emailForm.get('subject')?.setValue(savedEmail.emailSubject);
      }
      if (savedEmail.emailBody) {
        // Set the body value and trigger editor update
        this.emailForm.get('body')?.setValue(savedEmail.emailBody);
        
        // Force editor to recognize the content formatting
        setTimeout(() => {
          if (this.editor) {
            this.cdr.detectChanges();
          }
        }, 100);
      }
      
      // Restore selected template ID
      if (savedEmail.selectedTemplateId) {
        this.selectedTemplateId = savedEmail.selectedTemplateId;
      }
    }
  }

  fetchEmailTemplate() {
    this.isLoading = true;
    this.createProjectService.fetchEmailTemplate(this.userRole,this.workDayId)
      .pipe(finalize(() => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }))
      .subscribe((response) => {
        console.info("email template response", response);
        this.emailTemplates = response.payload.map((template: any) => ({
          ...template,
          timeAgo: this.getTimeAgo(template.updated_time)
        }))
        .sort((a: any, b: any) => {
          // Sort by updated_time in descending order (most recent first)
          return new Date(b.updated_time).getTime() - new Date(a.updated_time).getTime();
        });
        this.filteredEmailTemplates = [...this.emailTemplates];
        this.selectedTemplateId=this.createProjectService.getSelectedTemplateId() || null;

      });
  }

  filterTemplates() {
    const query = this.templateSearchQuery.toLowerCase().trim();
    if (query === '') {
      this.filteredEmailTemplates = [...this.emailTemplates];
    } else {
      this.filteredEmailTemplates = this.emailTemplates.filter(template =>
        template.template_name.toLowerCase().includes(query)
      );
    }
  }

  getTimeAgo(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMs = now.getTime() - date.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));

    if (diffInDays > 0) {
      return diffInDays === 1 ? '1 day ago' : `${diffInDays} days ago`;
    } else if (diffInHours > 0) {
      return diffInHours === 1 ? '1 hour ago' : `${diffInHours} hours ago`;
    } else if (diffInMinutes > 0) {
      return diffInMinutes === 1 ? '1 minute ago' : `${diffInMinutes} minutes ago`;
    } else {
      return 'Just now';
    }
  }

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'bullet_list'],
    ['link', 'align_left'],
  ];

  ngOnDestroy(): void {
    this.editor.destroy();
    this.popupEditor.destroy();
  }

  isValidEmail(email: string): boolean {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return regex.test(email);
  }


  toggleCcBcc(type: string): void {
    if (type === 'cc') {
      this.showCc = !this.showCc;
    } else if (type === 'bcc') {
      this.showBcc = !this.showBcc;
    }
  }

  remove(type: 'cc' | 'bcc') {
    this.emailForm.get(type)?.setValue('');
    if (type === 'cc') {
      this.showCc = false;
    } else if (type === 'bcc') {
      this.showBcc = false;
    }
  }

  formatDate(date: any): string {
    if (!date){ return ''};
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  }

  applyTemplate(template: any) {
    if (!template) {return};

    // Toggle selection: if already selected, unselect it and clear the form
    if (this.selectedTemplateId === template.template_id) {
      this.selectedTemplateId = null;
      // Clear persisted selection in service
      this.createProjectService.setSelectedTemplateId(null);
      this.emailForm.patchValue({
        subject: '',
        body: '',
        templateId: ''
      }, { emitEvent: false });
      this.emitFormValue();
      return;
    }
    
    this.selectedTemplateId = template.template_id;
    this.emailForm.get('templateId')?.setValue(this.selectedTemplateId, { emitEvent: false });
    // Persist selected template so card stays selected across reloads/navigation
    this.createProjectService.setSelectedTemplateId(this.selectedTemplateId);
    
    // Apply template content into the compose form
    this.applyTemplateToEmailForm(template);
  }


  private applyTemplateToEmailForm(template: any) {
    if (!template) {return};

    // Get collectionName and projectName
    const collectionName = this.collectionName?.collection_name || '';
    const projectName = this.projectName?.projectName || '';
    const deptName = this.deptName?.map((a: any) => a.name)?.join(',') || '';
    const dueDate = this.formatDate(this.projectName?.dueDate);
    const cnra = this.projectName?.contactPerson || '';
    const instructionType = this.projectName?.instructionType || '';
    console.info('applyTemplateToEmailForm', template);

    let subject = template.email_subject || '';
    let body = template.email_body || '';

    // Replace placeholders with actual values
    subject = subject.replaceAll(/\[Collection Name\]/gi, collectionName);
    body = body.replaceAll(/\[Collection Name\]/gi, collectionName);

    subject = subject.replaceAll(/\[Project Name\]/gi, projectName);
    body = body.replaceAll(/\[Project Name\]/gi, projectName);

    subject = subject.replaceAll(/\[Department\]/gi, deptName);
    body = body.replaceAll(/\[Department\]/gi, deptName);

    // Replace CNRA placeholders with actual contact person
    subject = subject.replaceAll(/\[CNRA\]/gi, cnra);
    body = body.replaceAll(/\[CNRA\]/gi, cnra);

    // Replace Instruction Type placeholders
    subject = subject.replaceAll(/\[Instruction Type\]/gi, instructionType);
    body = body.replaceAll(/\[Instruction Type\]/gi, instructionType);

    // Replace due date placeholders with actual date
    subject = subject.replaceAll(/\[Due Date\]/gi, dueDate)
      .replaceAll(/\{\{dueDate\}\}/gi, dueDate);
    body = body.replaceAll(/\[Due Date\]/gi, dueDate)
      .replaceAll(/\{\{dueDate\}\}/gi, dueDate);

    console.info('Applying template to email form:', body);

    this.emailForm.patchValue({
      subject: subject,
      body: body
    });

    // Force editor to recognize HTML formatting and update toolbar
    setTimeout(() => {
      if (this.editor) {
        this.cdr.detectChanges();
      }
    }, 100);

    this.emitFormValue();
  }

  emitFormValue() {
    if (this.emailForm.valid) {
      const formData = {
        ...this.emailForm.value,
        selectedTemplateId: this.selectedTemplateId
      };
      this.emailFormValue.emit(formData);
    }
  }

  addNewTemplate() {
    // Open the compact overlay popup for creating a new template
    this.isEditingTemplate = false;
    this.editingTemplateId = null;
    this.templateForm.reset();
    this.showTemplatePopup = true;
  }

  editTemplate(template: any, event: Event) {
    event.stopPropagation(); // Prevent applying template when clicking edit
    // Open popup with existing template data for editing
    this.isEditingTemplate = true;
    this.editingTemplateId = template.id || template.template_id;
    this.templateForm.patchValue({
      template_name: template.template_name,
      email_subject: template.email_subject,
      email_body: template.email_body
    });
    this.showTemplatePopup = true;
  }

  updateTemplate() {
    this.saveOrUpdateTemplate(true);
  }

  saveTemplate() {
    this.saveOrUpdateTemplate(false);
  }

  private saveOrUpdateTemplate(isUpdate: boolean) {
    // Require at least a template name

    console.info("templateform", this.templateForm.value);
    // return;
    if (!this.templateForm.get('template_name')?.valid) {return};
    const temp = this.templateForm.value;


    const payload: any = {
      templateName: temp.template_name,
      emailSubject: temp.email_subject,
      emailBody: temp.email_body
    };

    // Add templateId for update operation
    if (isUpdate) {
      payload.templateId = String(this.editingTemplateId);
    }

    console.info(isUpdate ? "Update template payload" : "Save template payload", payload);

    // Call appropriate API method
    const apiCall = isUpdate 
      ? this.createProjectService.editEmailTemplate(this.workDayId, payload)
      : this.createProjectService.saveEmailTemplate(this.workDayId, payload);

    apiCall.subscribe({
      next: (response) => {
        console.info(isUpdate ? "Template updated successfully" : "Template saved successfully", response);
        const templateData = response.payload || response;

        const newTemplate = {
          template_id: isUpdate ? this.editingTemplateId : (templateData.template_id || templateData.id),
          template_name: templateData.template_name || payload.templateName,
          email_subject: temp.email_subject,
          email_body: payload.emailBody,  // Use the stripped plain text version for storage
          updated_time: templateData.updated_time || new Date().toISOString(),
          timeAgo: this.getTimeAgo(templateData.updated_time || new Date().toISOString())
        };

        if (isUpdate) {
          // Update existing template in the array and move to top
          const index = this.emailTemplates.findIndex(t => 
            (t.id || t.template_id) === this.editingTemplateId
          );
          if (index !== -1) {
            // Remove from current position
            this.emailTemplates.splice(index, 1);
          }
          // Add updated template to the top
          this.emailTemplates.unshift(newTemplate);
          
          // Check if the updated template is the currently selected one
          if (this.selectedTemplateId && String(this.selectedTemplateId) === String(this.editingTemplateId)) {
            // Re-apply the template content to refresh the compose email
            console.info('Re-applying updated template to compose email');
            this.applyTemplateToEmailForm(newTemplate);
          }
        } else {
          // Add new template to the beginning of the array
          this.emailTemplates.unshift(newTemplate);
        }

        try { this.cdr.detectChanges(); } catch (e) { console.trace('Error in detectChanges:', e); }
        this.filteredEmailTemplates = [...this.emailTemplates];
        this.closeTemplatePopup();
        this.fetchEmailTemplate();
      },
      error: (error) => {
        console.trace(isUpdate ? 'Error updating template:' : 'Error saving template:', error);
      }
    });
  }

  closeTemplatePopup() {
    this.showTemplatePopup = false;
    this.templateForm.reset();
    this.isEditingTemplate = false;
    this.editingTemplateId = null;
  }

  // Drag and drop functionality
  onDragStart(event: DragEvent, placeholder: string) {
    event.dataTransfer?.setData('text/plain', placeholder);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent, target: 'subject' | 'body') {
    event.preventDefault();
    const placeholder = event.dataTransfer?.getData('text/plain');
    if (placeholder) {
      this.insertPlaceholderIntoField(placeholder, target);
    }
  }

  insertPlaceholder(placeholder: string) {
    // Use the last focused field
    this.insertPlaceholderIntoField(placeholder, this.lastFocusedField);
  }

  onSubjectFocus(event: FocusEvent) {
    this.lastFocusedField = 'subject';
    const target = event.target as HTMLTextAreaElement;
    this.lastCursorPosition = target.selectionStart || 0;
  }

  onSubjectClick(event: MouseEvent) {
    const target = event.target as HTMLTextAreaElement;
    this.lastCursorPosition = target.selectionStart || 0;
  }

  onBodyFocus() {
    this.lastFocusedField = 'body';
  }

  onEditorClick(event: MouseEvent): void {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const link = target.closest<HTMLAnchorElement>('a[href]');
    if (!link) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    window.open(link.href, link.target || '_blank', 'noopener,noreferrer');
  }

  insertPlaceholderIntoField(placeholder: string, target: 'subject' | 'body') {
    if (target === 'subject') {
      const subjectElement = document.getElementById('template-subject') as HTMLTextAreaElement;
      if (subjectElement) {
        const currentValue = this.templateForm.get('email_subject')?.value || '';
        const newValue = currentValue + placeholder;
        this.templateForm.patchValue({
          email_subject: newValue
        });
        // Set cursor position at the end
        setTimeout(() => {
          subjectElement.focus();
          const endPosition = newValue.length;
          subjectElement.setSelectionRange(endPosition, endPosition);
        }, 0);
      }
    } else if (target === 'body') {
      // For ngx-editor, append placeholder at the end of existing content inline
      let currentValue = this.templateForm.get('email_body')?.value || '';
      
      // Remove closing tags if they exist
      currentValue = currentValue.replaceAll(/<\/p>\s*$/gi, '');
      currentValue = currentValue.replaceAll(/<\/div>\s*$/gi, '');
      
      // Add a space and placeholder, then close the tag
      let newValue;
      if (currentValue.includes('<p>') || currentValue.includes('<div>')) {
        newValue = `${currentValue} ${placeholder}</p>`;
      } else {
        newValue = currentValue ? `${currentValue.trimEnd()} ${placeholder}` : placeholder;
      }
      
      this.templateForm.patchValue({
        email_body: newValue
      });
      // Force change detection
      this.cdr.detectChanges();
    }
  }


}
